export default __webpack_public_path__ + "static/media/vault-of-gore.920fb59a.jpg";